import { FunctionComponent } from "react";

import {
  FontIcon,
  Stack,
  TextBadge,
  TextBadgeColor,
  TextBadgeSize,
  useTheme
} from "@bps/fluent-ui";
import { DATE_FORMATS, DateTime } from "@bps/date-time";
import {
  CustomerProductsSubscription,
  SubscriptionStatuses
} from "@libs/api/gateways/plt/plt-gateway.dtos";

interface SubscriptionStatusBadgeProps {
  item: CustomerProductsSubscription;
  horizontal?: boolean;
}
export const SubscriptionStatusBadge: FunctionComponent<SubscriptionStatusBadgeProps> = ({
  item,
  horizontal
}) => {
  const theme = useTheme();
  const getColor = () => {
    switch (item.status) {
      case SubscriptionStatuses.Active:
        return TextBadgeColor.green;
      case SubscriptionStatuses.Canceled:
      case SubscriptionStatuses.PastDue:
      case SubscriptionStatuses.IncompleteExpired:
        return TextBadgeColor.red;
      default:
        return TextBadgeColor.yellow;
    }
  };
  return item.cancelAtPeriodEnd ? (
    <Stack
      horizontal={horizontal}
      verticalAlign="center"
      tokens={{ childrenGap: 4 }}
    >
      <TextBadge
        badgeSize={TextBadgeSize.small}
        badgeColor={TextBadgeColor.yellow}
        hasBorder
        styles={{
          root: { flexDirection: "row" }
        }}
      >
        <FontIcon
          iconName="Warning"
          styles={{
            root: {
              color: theme.semanticColors.errorIcon,
              fontSize: 14,
              marginRight: 3
            }
          }}
        />
        Pending cancellation (
        {item.cancelAtPeriodEnd &&
          DateTime.fromISO(item.cancellationDate).toFormat(
            DATE_FORMATS.DAY_DEFAULT_FORMAT
          )}
        )
      </TextBadge>
    </Stack>
  ) : (
    <TextBadge
      badgeSize={TextBadgeSize.small}
      badgeColor={getColor()}
      hasBorder
      styles={{ root: { textTransform: "capitalize" } }}
    >
      {item.status}
    </TextBadge>
  );
};
